import {InputDate} from '@/components/commons/input-date-legacy/InputDate'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useTranslation} from '@/translations/i18n'
import dayjs from 'dayjs'
import {Controller, useFormContext, useWatch} from 'react-hook-form'
import {acceptedFileTypes} from '@/features/users/utils'
import {useUploadDocument} from '@/services/useUploadDocument'
import {toast} from '@/utilities/toast/toast'
import {UserCurriculumFormValidationSchema} from '@/features/users/types'
import {useDeleteDocument} from '@/services/useDeleteDocument'
import {FileUploader} from '@/components/commons/file-upload/FileUpload'

export const UserCurriculumForm = () => {
    const {t} = useTranslation()

    // methods
    const form = useFormContext<UserCurriculumFormValidationSchema>()

    // mutation
    const uploadDocument = useUploadDocument({
        onSuccess: response => {
            form.setValue('curriculumAttachment', response, {shouldDirty: true})
            toast.success(t('commons:upload_success'))
        },
        onError: () => toast.error(t('commons:upload_error'))
    })
    const deleteDocument = useDeleteDocument({
        onSuccess: () => {
            form.setValue('curriculumAttachment', null, {shouldDirty: true})
        }
    })

    // form observer
    const cvAttachment = useWatch({name: 'curriculumAttachment', control: form.control})

    return (
        <Flexbox align="flex-end" gap={2}>
            <Controller
                control={form.control}
                name="curriculumLastUpdate"
                render={({field}) => (
                    <InputDate
                        label={t('users:cv_last_update')}
                        placeholder="GG/MM/AAAA"
                        errorMessage={form.formState.errors.curriculumLastUpdate?.message}
                        maxDate={dayjs().toDate()}
                        numMonths={1}
                        fullWidth
                        selectedDates={field.value ? [field.value] : []}
                        onChange={field.onChange}
                    />
                )}
            />

            <FileUploader
                document={cvAttachment}
                isLoading={uploadDocument.isPending || deleteDocument.isPending}
                onDeleteFile={deleteDocument.mutate}
                dropDownMenuProps={{
                    triggerWidth: '150px'
                }}
                inputFileProps={{
                    acceptedFiles: acceptedFileTypes,
                    maxSizeInMB: 8,
                    textButton: t('commons:upload'),
                    onAcceptFiles: file => {
                        const formData = new FormData()
                        formData.append(`file`, file)
                        uploadDocument.mutate(formData)
                    },
                    hideFilename: true,
                    width: 'auto'
                }}
            />
        </Flexbox>
    )
}
